import React from "react";
import { css } from "emotion";
import { formatCurrency, intFormat } from "../../../../../js/shared/utils";
import { totalStyle } from "./style";

const QuickOfferTotal = ({ quantMiles, price }) => {
	return (
		<div
			className={css`
				${totalStyle};
			`}
		>
			<h1>
				<span>R$</span> {formatCurrency(price * quantMiles / 1000, " ")}
			</h1>
			<h5>Valor para {intFormat(quantMiles)} milhas</h5>
			<hr />
		</div>
	);
};

export default QuickOfferTotal;
